import { CheckoutStatus, CheckoutType, Money, RefundStatus } from '../booking/booking'
import { CancelReason } from '../court/court'
import { PaymentMethod, PaymentStatus } from '../payment/payment'

/** AVAILABLE = value left and not expired; USED = nothing left; EXPIRED = value left past its expiry. */
export enum RefundPointStatus {
  AVAILABLE = 'AVAILABLE',
  USED = 'USED',
  EXPIRED = 'EXPIRED',
}

/** RESERVED = held for a checkout waiting for payment; COMMITTED = spent; RELEASED = given back. */
export enum RefundPointUsageStatus {
  RESERVED = 'RESERVED',
  COMMITTED = 'COMMITTED',
  RELEASED = 'RELEASED',
}

export type RefundPointUsage = {
  checkoutId: string
  checkoutType: CheckoutType
  amount: number
  status: RefundPointUsageStatus
  createdAt: string
}

/** Refund points returned for one cancelled paid booking (1 point = 1 RON). */
export type RefundPoint = {
  id: number
  amount: number
  remainingAmount: number
  status: RefundPointStatus
  cancelReason?: CancelReason
  createdAt: string
  expiresAt: string
  bookingId: number
  clubName?: string
  courtName?: string
  bookingStartTime?: string
  usages: RefundPointUsage[]
}

export type RefundPointSummary = {
  /** Points that can be spent now. */
  available: number
  /** Points of the balance that expire first, at nextExpiresAt. */
  nextExpiryAmount?: number
  nextExpiresAt?: string
}

/** One purchase of the authenticated user: money paid by card or offline, refund points, or both. */
export type MyPayment = {
  checkoutId: string
  type: CheckoutType
  status: CheckoutStatus
  createdAt: string
  /** Club and court of the first session, or the pass name. */
  description?: string
  amount: Money
  pointsAmount: number
  paymentMethod?: PaymentMethod
  paymentStatus?: PaymentStatus
  refundStatus?: RefundStatus
}
